import React from 'react';
import {ThemeProvider} from '@material-ui/core/styles';
import {createMuiTheme} from '@material-ui/core';

import ContentArea from '../components/content_area';
import Header from '../components/header';

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: '#661024',
    },
  },
});

export default function Theme() {
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <ContentArea />
    </ThemeProvider>
  );
}
